import { defineStore } from "pinia";

import { login, getUserDetailInfo } from "@/api/auth";
import { getBasicInfo } from "@/api/expo/company";

export const useUserStore = defineStore("user", {
  persist: {
    storage: sessionStorage,
  },
  state: () => ({
    token: "",
    userInfo: null,
    organizationInfo: null,
  }),
  actions: {
    setToken(token) {
      this.token = token;
    },
    logout() {
      this.$reset();
    },
    resetAccount(account) {
      this.accountInfo = account;
    },
    refreshAccount(account) {
      this.accountInfo.name = account.name;
      const properties = this.accountInfo.properties || {};
      properties.avatar = account.avatar;
      this.accountInfo.properties = properties;
    },
    onLogin(params) {
      return new Promise((resolve, reject) => {
        login(params)
          .then((res) => {
            const { token, user } = res;
            // debugger
            this.token = token;
            this.userInfo = user;
            resolve(res);
            // this.getInfo(res);
          })
          .catch((error) => reject(error));
      });
    },
    getExhibitorInfo(id) {
      getBasicInfo(id).then((res) => {
        this.exhibitorInfo = res;
      });
    },
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getUserDetailInfo()
          .then((res) => {
            this.userInfo = res;
            resolve(res);
          })
          .catch((error) => reject(error));
      });
    },
    getUserDetail() {
      return getUserDetailInfo();
    },
  },
});
